import { render, staticRenderFns } from "./Remote.vue?vue&type=template&id=d6b4a17e&"
import script from "./Remote.vue?vue&type=script&lang=js&"
export * from "./Remote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports